// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2SeGy","right":"styles_right__2ylnH"};